import tw, { type TwStyle } from 'twin.macro';

import Button from '../Button';
import Modal from './Modal';

type ModalFooterWithButtonsProps = {
  declineOnClick?: (...args: unknown[]) => void;
  declineText?: string;
  acceptOnClick?: (...args: unknown[]) => void;
  acceptText: string;
  isLoading?: boolean;
  acceptTypeSubmit?: boolean;
  acceptDisabled?: boolean;
  fixed?: boolean;
  acceptStyles?: TwStyle;
};

const ModalFooterWithButtons = ({
  declineOnClick,
  declineText,
  acceptOnClick,
  acceptText,
  isLoading = false,
  acceptTypeSubmit = false,
  acceptDisabled = false,
  fixed = false,
  acceptStyles,
}: ModalFooterWithButtonsProps) => {
  const areTwoButtons = !!(declineOnClick && declineText);

  return (
    <Modal.Footer data-cy="ModalFooterWithButtons" fixed={fixed}>
      <div tw="flex flex-col-reverse sm:flex-row w-full justify-end gap-4">
        {areTwoButtons && (
          <Button
            variant="outlined"
            styles={{
              button: tw`basis-full sm:basis-[160px] whitespace-nowrap`,
            }}
            onClick={declineOnClick}
            isLoading={isLoading}
          >
            {declineText}
          </Button>
        )}
        <Button
          data-testid="ModalFooterWithButtons__Button-accept"
          variant="contained"
          color="primary"
          styles={{
            button: [
              tw`basis-full whitespace-nowrap`,
              areTwoButtons && tw`sm:basis-[160px]`,
              acceptStyles ?? false,
            ],
          }}
          onClick={acceptOnClick}
          isLoading={isLoading}
          type={acceptTypeSubmit ? 'submit' : 'button'}
          disabled={acceptDisabled}
        >
          {acceptText}
        </Button>
      </div>
    </Modal.Footer>
  );
};

export default ModalFooterWithButtons;
